import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import RichText from '@components/atoms/RichText';
import Media from '@components/atoms/Media';
import HeaderFont from '@components/atoms/HeaderFont';

const BodyCopy = ({ data }) => {
  const {
    introBlock: {
      title: {
        data: { title: introTitle }
      },
      content: {
        data: { content: introContent }
      },
      image: introImage
    },
    heroText: {
      content: {
        data: { content: heroContent }
      }
    },
    descriptionBlock: {
      content: {
        data: { content: descriptionContent }
      },
      image: descriptionImage
    }
  } = data;

  return (
    <Wrapper narrow>
      <Flex alignItems="center" direction={{ base: `column`, md: `row` }}>
        <Box pr={{ base: `0`, md: `5rem` }} maxWidth="32.24rem">
          <HeaderFont
            as="h3"
            pb="1.53rem"
            letterSpacing="0.1rem"
            fontStyle="italic"
            color="purple.600"
            fontSize={{ base: `6xl`, md: `7xl` }}
            lineHeight={{ base: `3.75rem`, md: `4.5rem` }}
            textTransform="uppercase"
            transform="rotate(-5deg)"
            sx={{
              color: `white`,
              WebkitTextStroke: `2px #410286`,
              b: {
                WebkitTextStroke: `0`,
                color: `purple.600`
              }
            }}>
            <RichText data={introTitle} />
          </HeaderFont>
          <Box
            fontSize={{ base: `sm`, md: `lg` }}
            lineHeight={{ base: `1.313rem`, md: `1.688rem` }}>
            <RichText data={introContent} />
          </Box>
        </Box>
        <Media
          mt={{ base: `2`, md: `0` }}
          mb={{ base: `2`, md: `0` }}
          pl={{ base: `0`, md: `0` }}
          media={introImage}
        />
      </Flex>
      <Box
        pr={{ base: `0`, md: `15.875rem` }}
        pt={{ base: `0`, md: `6` }}
        sx={{
          h2: {
            fontSize: { base: `2xl`, md: `4xl` },
            fontWeight: `600`,
            fontFamily: `'AvenirNext', Arial, sans-serif`,
            fontStyle: `normal`,
            lineHeight: { base: `2.25rem`, md: `3.375rem` }
          },
          i: {
            fontWeight: `900`,
            fontStyle: `italic`,
            textTransform: `uppercase`,
            fontFamily: `'AvenirNextCondensed', Arial, sans-serif`
          }
          // TODO: Handle this with the text colour plugin?
          // i: {
          //   color: `purple.400`,
          //   fontStyle: `normal`
          // }
        }}>
        <RichText data={heroContent} />
      </Box>
      <Flex
        pb={{ base: `14`, md: `16` }}
        alignItems="center"
        direction={{ base: `column-reverse`, md: `row` }}
        sx={{
          b: {
            color: `purple.400`
          }
        }}>
        <Box pr="3.125rem" fontSize="xl" lineHeight="1.875rem">
          <RichText data={descriptionContent} />
        </Box>
        <Media
          mt={{ base: `2`, md: `0` }}
          mb={{ base: `6`, md: `0` }}
          media={descriptionImage}
        />
      </Flex>
    </Wrapper>
  );
};

export default BodyCopy;
